import { DoubleArrow } from "@mui/icons-material";
import { Interval } from "./Workout";
import "./WorkoutView.css";
import React, { Fragment } from "react";
import { SecondsToMinutesAndSeconds } from "../utils/Time";
import WorkoutPlayer from "./WorkoutPlayer";
import { ColorProvider } from "./IntervalColors";
import { WorkoutViewModel } from "./WorkoutViewModel";


interface WorkoutProps
{
    workoutPlayer: WorkoutPlayer;
}

export default class WorkoutView extends React.Component<WorkoutProps>
{
    private colorProvider = new ColorProvider();

    render()
    {
        const workout = this.props.workoutPlayer.Workout;
        const player = this.props.workoutPlayer;
        const workoutViewModel = new WorkoutViewModel(workout);
        return(
            <div className="WorkoutView">
                <div>{workout.Name}</div>
                <div className="IntervalsChart">
                    <table style={{borderSpacing: 0}}>
                        <tbody>
                            {
                            workoutViewModel.Groups.map((group, index) => (
                                group.Intervals.slice(0, group.Size).map((interval, intervalIndex) => {
                                    const isCurrentGroup = player.CurrentInterval && group.Intervals.includes(player.CurrentInterval);
                                    const isCurrentInterval = player.CurrentInterval && WorkoutViewModel.sameInterval(player.CurrentInterval, interval);
                                    const isArrowVisible = isCurrentGroup && isCurrentInterval;
                                    const repetition = workoutViewModel.getGroupRepetition(player.CurrentTime, group);

                                return <Fragment key={index * 1000 + intervalIndex}>
                                    <tr>
                                        <td>
                                            <div className='cell' style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>
                                                <DoubleArrow sx={{verticalAlign: 'bottom'}} style={{visibility: isArrowVisible ? 'visible' : "hidden"}}/>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='cell' style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>
                                                <span>{interval.Name}</span>
                                            </div>
                                        </td>

                                        { intervalIndex == 0 && group.Size > 1 && 
                                            <td rowSpan={group.Size} style={{textAlign: 'center'}}>
                                                <div className="cell2" style={{display: "grid", gridTemplateAreas: "inner-div", placeItems: "center", padding: "0"}}>
                                                    <div style={{gridArea: "inner-div", width: "100%", margin: "0", padding: "0", display: 'flex', flexDirection: 'column'}}>
                                                        {group.Intervals.slice(0, group.Size).map(ii =>
                                                            (<div className='cell multicell' style={{ backgroundColor: this.colorProvider.getIntervalColor(ii)}}></div>))
                                                        }
                                                    </div>
                                                    <div className='multicell-ratio' style={{gridArea: "inner-div"}}>
                                                        <div className="cell multicell-up">
                                                            {repetition}
                                                        </div>
                                                        <div className="cell multicell-down">
                                                            {group.Intervals.length / group.Size}
                                                        </div>
                                                    </div>
                                                    <div style={{gridArea: "inner-div", rotate: "45deg", fontSize: '1.5rem', fontWeight: '100' }}>|</div>
                                                </div>
                                            </td>
                                        }
                                        { group.Size == 1 &&
                                            <td>
                                                <div className="cell" style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>&nbsp;</div>
                                            </td>

                                        }

                                        <td style={{textAlign: 'right'}}>
                                            <div className='cell' style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>
                                            {player.NormalizePower(interval.GetTargetPowerAtTime(0) ?? 0)}
                                            <span style={{opacity: 0.5, fontSize: '0.7rem'}}>W</span>
                                            </div>
                                        </td>
                                        <td style={{textAlign: 'right'}}>
                                            <div className='cell' style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>
                                                {interval.TargetCadence ? interval.TargetCadence : "*"}
                                                <span style={{opacity: 0.5, fontSize: '0.7rem'}}>RPM</span>
                                            </div>
                                        </td>
                                        <td>
                                            <div className='cell' style={{ backgroundColor: this.colorProvider.getIntervalColor(interval)}}>
                                                {SecondsToMinutesAndSeconds(interval.TotalSeconds)}
                                            </div>
                                        </td>
                                    </tr>
                                    {/* {index < workout.Intervals.length - 1 &&
                                        <tr style={{height: '2px'}}></tr>
                                    } */}
                                </Fragment>
                                })
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    isCurrentInterval(interval: Interval) : boolean
    {
        return this.props.workoutPlayer.CurrentInterval == interval;
    }
}

